import { useQueryClient as e } from "@maat/store-hooks";
import { useLogout as t } from "@maat/store-auth";
//#region src/account-deletion/useAccountDeletionTeardown.ts
var n = () => {
	let n = e(), { logout: r } = t();
	return async () => {
		try {
			await r();
		} catch {} finally {
			n.clear();
		}
	};
};
//#endregion
export { n as useAccountDeletionTeardown };
